<script setup>
import { ref } from 'vue';
import moment from 'moment';

const status = ref(false)

const props = defineProps({
  state: {
    type: Object,
    default: () => ({})
  },
  activeNames: {
    type: Array,
    default: () => []
  }
})

const ColorStyle = [
  'replenish-item__price__first',
  'replenish-item__price__second',
  'replenish-item__price__third',
  'replenish-item__price__fourth'
]
    
const formatTime = (t) => {
  return moment(t).format('YYYY/MM/DD')
}
</script>
<template>
  <div class="payTypes-text-box">
    <van-collapse :model-value="props.activeNames" class="pay-collapse mb-10">
      <van-collapse-item v-if="!status" class="collapse-item" @click="status = !status">
        <template #value>
          <van-notice-bar left-icon="warning" background="#F1F1FF" color="#1E183F" class="notice-bar">
            <span>We have recharge bonus activity,you can<a class="text-main">
              check more information</a>.</span>
          </van-notice-bar>
        </template>
      </van-collapse-item>
    </van-collapse>
    <div v-if="status" class="more-info" v-html="props.state.desc" />
    <div v-if="status">
      <div class="replenish-body">
        <div
          v-for="(item, index) in props.state.rewardList"
          :key="index"
          class="replenish-item"
          :class="ColorStyle[(index % 4)]"
        >
          <div class="replenish__price">
            <span class="replenish__price-title">
              Single Recharge
            </span>
            <p v-if="index !== props.state.rewardList.length - 1" class="replenish__price-content">
              ${{ item.min / 100 }}{{ index === 0 ? '&lt;=' : '&lt;' }}amount&lt;=${{ item.max / 100 }}
            </p>
            <p v-else class="replenish__price-content">
              amount>${{ item.min / 100 }}
            </p>
            <div v-show="index === props.state.rewardList.length - 1" class="replenish-tips_1">
              Best
            </div>
          </div>
          <div class="replenish__content">
            <div>
              <div class="">Regular Bonus</div>
              <div class="price-number">
                +{{ item.rate }}%
              </div>
            </div>
            <div v-if="props.state.replenishActivityIsOpen && item.subject && item.content">
              <div>
                <div>
                  {{ item.subject }}
                </div>
                <div>
                  ({{ formatTime(props.state.eTime) }} Cut off)
                </div>
              </div>
              <div class="price-number">
                {{ item.content }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="space" />
  </div>
</template>
<style lang="scss" scoped>

.payTypes-text-box {
  // padding: 0;

  .pay-collapse::after {
    border: none;
  }

  .more-info {
    width: calc(100vw - 20px);
    margin-bottom: 20px;

    :deep(& > p:last-child) {
      margin-top: 20px;
    }

    :deep(img){
      width: 100%;
    }
  }

  .collapse-item {
    :deep(.van-cell) {
      padding: 0;
      height: 40px;
      background: #f1f1ff;

      .van-cell__value {
        & > div {
          padding-right: 0;
        }
      }

      .van-cell__right-icon {
        padding-right: 10px;
        height: 40px;
        line-height: 40px;
        font-size: 14px;
      }
    }

    :deep(.van-collapse-item__wrapper) {
      .van-collapse-item__content {
        padding: 0 10px;
      }
    }
  }
}
@import './replenish.scss';
</style>